import { RadioFieldFragmentFragment } from '../../../../__generated__/graphql';
import Radio from '../../../../components/Radio';
import { Paragraph } from '../../../../components/Text';
import { useGravityFormsDispatch, useSelectInitialized, useSelectRadioFieldValue } from '../../state/hooks';
import ConditionalWrapper from '../ConditionalWrapper';
import FieldErrors from '../FieldErrors';
import FormFieldGridContainer from '../FormFieldGridContainer';

interface Props {
  field: RadioFieldFragmentFragment;
}

const RadioInput = ({ field }: Props) => {
  const {
    choices,
    conditionalLogic,
    databaseId,
    description,
    isRequired,
    label,
    layoutGridColumnSpan,
  } = field;

  const dispatch = useGravityFormsDispatch();

  const fieldValue = useSelectRadioFieldValue(databaseId);
  const initialized = useSelectInitialized();

  if (initialized && !fieldValue) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      payload: {
        id: databaseId,
        value: e.target.value,
      },
      type: 'updateRadioFieldValue',
    });
  };

  return (
    <ConditionalWrapper conditionalLogic={conditionalLogic}>
      <FormFieldGridContainer layoutGridColumnSpan={layoutGridColumnSpan}>
        <Radio
          label={label ?? ''}
          name={databaseId.toString()}
          onChange={handleChange}
          options={choices?.map(choice => ({
            label: choice?.text ?? '',
            value: choice?.value ?? '',
          })) ?? []}
          required={!!isRequired}
        />

        {description && <Paragraph>{description}</Paragraph>}

        <FieldErrors fieldId={databaseId} />
      </FormFieldGridContainer>
    </ConditionalWrapper>
  );
};

export default RadioInput;
